module.exports = __webpack_public_path__ + "assets/img/detail-btn-9db0d0ac.png";